(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow-4"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slideshow-dot]'));
      this.current = 0;
      this.timer = null;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.slides.length < 2) return;

      const prev = this.querySelector('[data-slideshow-prev]');
      const next = this.querySelector('[data-slideshow-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.current - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.current + 1, true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.slideshowDot, 10), true));
      });

      // Pause on hover / focus, resume on leave
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      // Pause when tab is hidden
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      });

      // Pause when scrolled off screen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.start();
              else this.stop();
            });
          },
          { threshold: 0.2 }
        ).observe(this);
      }

      // Touch swipe
      let startX = 0;
      this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      this.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 50) this.go(this.current + (delta < 0 ? 1 : -1), true);
      }, { passive: true });

      this.syncVideos();
      this.start();

      // Theme editor support
      if (Shopify && Shopify.designMode) {
        this.closest('.shopify-section')?.addEventListener('shopify:block:select', (e) => {
          const slide = e.target.closest('.hero-slideshow__slide');
          if (slide) {
            this.stop();
            this.go(parseInt(slide.dataset.slideIndex, 10), false);
          }
        });
        this.closest('.shopify-section')?.addEventListener('shopify:block:deselect', () => this.start());
      }
    }

    go(index, userInitiated) {
      const count = this.slides.length;
      this.current = ((index % count) + count) % count;

      this.slides.forEach((slide, i) => {
        const active = i === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.syncVideos();

      if (userInitiated) {
        this.stop();
        this.start();
      }
    }

    syncVideos() {
      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (i === this.current) {
          video.muted = true;
          const p = video.play();
          if (p) p.catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    start() {
      if (!this.autoplay || this.reducedMotion || this.timer) return;
      this.timer = setInterval(() => this.go(this.current + 1, false), this.speed);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
